const wm = (path, w = 1280) => {
  const name = path.split("/").pop();
  return `https://upload.wikimedia.org/wikipedia/commons/thumb/${path}/${w}px-${name}`;
};
/* Stable Wikimedia Commons URL by file name (verified to resolve) */
const wiki = (name, w = 1280) => `https://commons.wikimedia.org/wiki/Special:FilePath/${encodeURIComponent(name)}?width=${w}`;

export const IMAGES = {
  hero: wiki("Forum (Pompeii) and the Vesuvio.jpg", 1920),
  tailor: wm("a/a4/Reggia_di_Caserta_2023.jpg", 1280),
  about: wm("3/3c/View_of_Spaccanapoli_and_the_Centro_Direzionale_from_Castel_Sant%27Elmo%2C_Naples%2C_2010.jpg", 1920),
  contact: wiki("Spaccanapoli, Via dei Tribunali, Naples, Italy (18036064939).jpg", 1280),
  gods: wiki("Herculaneum - The Ruins, The Present Town And Mount Vesuvius.jpg", 1280),
  packages: wiki("Napoli, Piazza Plebiscito e Palazzo Reale 1.jpg", 1920),
  /* AMS Visual Library (AI concept images, small editorial use only) */
  strip: [
    { src: "/images/09_napoli_pizza_concept.webp", alt: "Neapolitan pizza" },
    { src: "/images/17_limoni_costiera_concept.webp", alt: "Amalfi Coast lemons" },
    { src: "/images/21_affreschi_antichi_concept.webp", alt: "Ancient Roman frescoes" },
    { src: "/images/12_vicolo_costiera_concept.webp", alt: "Coastal alley with bougainvillea" },
    { src: "/images/08_terrazza_mare_concept.webp", alt: "Lunch on a Mediterranean terrace" },
    { src: "/images/11_vesuvio_trekking_concept.webp", alt: "Walking on Vesuvius" },
  ],
  moments: {
    food: "/images/20_pasta_mediterranea_concept.webp",
    culture: "/images/13_anfore_archeologia_concept.webp",
    coast: "/images/24_positano_scale_concept.webp",
    terrace: "/images/19_terrazza_classica_concept.webp",
  },
};

/* Destinations gallery (Home) -> /tours?destination=key. Only destinations in the approved AMS catalogue. */
export const DESTINATIONS = [
  { key: "pompei", image: wiki("Forum (Pompeii) and the Vesuvio.jpg", 1280) },
  { key: "napoli", image: wiki("View of Spaccanapoli and the Centro Direzionale from Castel Sant'Elmo, Naples, 2010.jpg", 960) },
  { key: "ercolano", image: wiki("Herculaneum - The Ruins, The Present Town And Mount Vesuvius.jpg", 960) },
  { key: "caserta", image: wiki("Reggia di Caserta 2022 (2).jpg", 960) },
];
